module.exports = __webpack_public_path__ + "static/media/gchat_step-3.e0e501ba.svg";